export const campaignSlugs = {
    DROPLETON_LEGACY_MIGRATION: "dropleton",
    HASHBROWN: "notion-discount",
    INTRO_STARTER: "starter-introductory-plan",
};

// @zapier/upsells@5.0.1 (c64b11b3c)
